// extracted by mini-css-extract-plugin
export default {"buildContainer":"build_buildContainer__CZWuX","buildDiv":"build_buildDiv__C84sk"};